import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0e084e0c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0e084e0c&prod&lang=scss"
import style1 from "./Footer.vue?vue&type=style&index=1&id=0e084e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e084e0c",
  null
  
)

export default component.exports